export const normalizeAiProviderValue = (value, fallback) => {
  const provider = String(value || "").trim().toLowerCase();
  if (provider === "anthropic" || provider === "openai") return provider;
  return fallback;
};

export const resolveCloudSessionState = ({
  reportHistoryPrivate,
  aiHistoryPrivate,
  autosaveEnabledPrivate,
  aiProviderPrivate,
  darkModePrivate,
  beurteilungStyleProfilePrivate,
  onboardingSeenPrivate,
  defaultAiProvider,
  normalizeBeurteilungStyleProfile,
}) => ({
  reportHistory: Array.isArray(reportHistoryPrivate?.value) ? reportHistoryPrivate.value : [],
  aiBefundHistory: Array.isArray(aiHistoryPrivate?.value) ? aiHistoryPrivate.value : [],
  autosaveEnabled: Boolean(autosaveEnabledPrivate?.value),
  aiProvider: normalizeAiProviderValue(aiProviderPrivate?.value, defaultAiProvider),
  beurteilungStyleProfile: normalizeBeurteilungStyleProfile(beurteilungStyleProfilePrivate?.value),
  isDarkTheme: Boolean(darkModePrivate?.value),
  onboardingSeen: onboardingSeenPrivate?.value === true,
});
